module.exports = __webpack_public_path__ + "img/purple-finch.eb17365c.jpg";